import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {PedidoLoja} from "../objeto/PedidoLoja";
import {ClienteService} from "../services/cliente.service";
import {CarrinhoService} from "../services/carrinho.service";
import {Router} from "@angular/router";
import {CurrencyPipe, Location} from "@angular/common";
import { formatCurrency } from '@angular/common';
import {Pagamento} from "../objeto/Pagamento";
import {NgForm} from "@angular/forms";
import {ITela} from "../objeto/ITela";
import {DominiosService} from "../services/dominios.service";
import {ConstantsService} from "../services/ConstantsService";
import {FormaDePagamento} from "../objeto/FormaDePagamento";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {TelaCartaoDeCreditoComponent} from "../app/tela-cartao-de-credito/tela-cartao-de-credito.component";
import {DialogCloseResult, DialogService} from "@progress/kendo-angular-dialog";
import {DadosCartao} from "../objeto/DadosCartao";
import {EnumMeioDePagamento} from "../objeto/EnumMeioDePagamento";
import {DadosPix} from "../objeto/DadosPix";
import {  Inject,  LOCALE_ID } from '@angular/core';

declare var fbq;

@Component({
  selector: 'app-loja-pagamento',
  templateUrl: './loja-pagamento.component.html',
  styleUrls: ['./loja-pagamento.component.scss']
})
export class LojaPagamentoComponent implements OnInit, ITela {
  @ViewChild('frm')  frm: NgForm;
  @ViewChild('txtTrocoM') txtTrocoM: ElementRef;
  @ViewChild('txtEmailPix', {static: false}) txtEmailPix: ElementRef;
  pedido: PedidoLoja;
  public formatOptions: any = {
    style: 'currency',
    currency: 'BRL'
  };
  pagamento: Pagamento;
  selecionou: boolean;
  nomePagina: string;
  msgErro: string;
  empresa: any = {};
  formasDePagamento: Array<FormaDePagamento> = [];
  formasDePagamentoOnline: Array<FormaDePagamento> = [];
  formasDePagamentoPix: Array<FormaDePagamento> = [];
  usarSaldo: any = false;
  cashback: any
  exigeCartao: boolean;
  dadosCartao: DadosCartao;
  telaPagamento: TelaCartaoDeCreditoComponent;

  constructor(@Inject(LOCALE_ID) public locale: string,
              private clienteService: ClienteService, private carrinhoService: CarrinhoService,
              private router: Router, private location: Location, private dominiosService: DominiosService,
              private autorizacao: AutorizacaoLojaService, private dialogService: DialogService,
              private constantsService: ConstantsService) {
    this.nomePagina = dominiosService.obtenhaRaizCardapio();
    this.pagamento = new Pagamento();
  }

  ngOnInit() {
    this.pedido = this.carrinhoService.obtenhaPedido();

    if( this.pedido.pagamento ) {
      this.pagamento = this.pedido.pagamento;
      this.exigeCartao = this.formaDePagamentoExigeCartao();
      this.habiliteTipoDinheiro();
    }

    this.constantsService.empresa$.subscribe( (empresa) => {
      if(empresa) {
        this.empresa = empresa;

        this.formasDePagamento = [];
        this.formasDePagamentoOnline = [];
        this.empresa.formasDePagamento.forEach(formaDePagamento => {
          if( !formaDePagamento.exibirCardapio)
            return;


          const formaDoPegido = this.pedido.pagamento.formaDePagamento;
          if( formaDoPegido && this.pedido.pagamento && formaDePagamento.id === formaDoPegido.id ) {
            formaDePagamento = this.pedido.pagamento.formaDePagamento;
          }

          if( !formaDePagamento.online ) {
            this.formasDePagamento.push(formaDePagamento);
          } else if( formaDePagamento.pix ) {
            this.formasDePagamentoPix.push(formaDePagamento);
          } else {
            this.formasDePagamentoOnline.push(formaDePagamento);
          }
        });

        delete this.cashback;
        delete this.pedido.cashback;

        if(this.empresa.integracaoPedidoFidelidade || this.empresa.integracaoFidelidade ){
          this.cashback = { saldo: 0, podeUsarNaLoja: this.empresa.integracaoFidelidade != null}
          this.clienteService.obtenhaSaldoCashback().then( cashback => {
            this.cashback = cashback;
            if( this.cashback){
              let valorPedido = this.pedido.obtenhaTotalSemTaxaEntrega();

              this.setPodeUsarCashback(valorPedido)
            }
          })
        }
      }
    });
  }



  setPodeUsarCashback(valorPedidoPagar: number){
    if(!this.cashback) return;

    this.cashback.podeUsarNoPedido = valorPedidoPagar >= this.cashback.minimoPedido;
    this.cashback.valor = this.cashback.saldo >  valorPedidoPagar ? valorPedidoPagar : this.cashback.saldo;
    if(this.cashback.usarPadrao && this.cashback.saldo  > 0)
      this.cashback.usar =   this.cashback.podeUsar &&   this.cashback.podeUsarNoPedido;


    if( this.cashback.usar)
      this.pedido.cashback = this.cashback
    else
      delete this.pedido.cashback

  }

  calculeTroco(valor: any) {
    this.pedido.pagamento = this.pagamento;

    setTimeout( () => {
      this.pedido.calculeTroco();
    }, 0);
  }

  onSubmit() {
    if( !this.frm.valid )
      return;

    if( this.pedido.troco < 0 ){
      this.msgErro = 'Valor para troco tem que ser maior do que o pedido';
      return;
    }

    if( this.pedido.troco > 500 ){
      this.msgErro = 'Valor para troco está muito acima do valor do pedido.';
      return;
    }

    this.pedido.pagamento = this.pagamento;

    if (typeof fbq !== 'undefined')
      fbq('track', 'AddPaymentInfo');

    if(this.pedido.entrega && this.pedido.entrega.valorComRetorno)
      this.pedido.calculeTotal();

    if(this.cashback && this.cashback.usar){
      this.pedido.cashback = this.cashback;
      this.pedido.calculeTroco();
    } else {
      delete this.pedido.cashback
    }

    this.carrinhoService.salvePedido(this.pedido);
    this.dominiosService.vaParaCarrinho();
  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu(){
    return false;
  }

  habiliteTipoDinheiro() {
    if( this.pagamento.formaDePagamento && this.pagamento.formaDePagamento.nome !== 'dinheiro' ) {
      this.pagamento.trocoPara = 0;
      this.pagamento.temTroco = '';
    }

    setTimeout( () => {
      if( !this.txtTrocoM ) {
        return;
      }
    }, 0);
  }

  alterouFormaDePagamentoParaPix() {
    this.pagamento.dadosPix = new DadosPix();

    this.alterouFormaDePagamento();

    setTimeout( () => {
      this.txtEmailPix.nativeElement.focus();
    }, 100);
  }

  alterouFormaDePagamento() {
    this.exigeCartao = this.formaDePagamentoExigeCartao();

    if(this.cashback && this.cashback.usar)
      this.pedido.cashback = this.cashback

    this.pedido.calculeTotal();
    delete  this.pedido.cashback;

    this.habiliteTipoDinheiro();
  }


  usarSaldoCartao() {

  }

  onSelectedChange(  selected) {
    this.usarSaldo = selected
  }


  obtenhaTotalPagar() {
    if(!this.cashback || !this.cashback.usar)
      return this.pedido.total;

    let totalPagar = this.pedido.total - this.cashback.valor;

    if(totalPagar <= 0){
      totalPagar = 0;
      delete this.pagamento.formaDePagamento
    }

    return Number(totalPagar.toFixed(2));
  }

  escolheuFormaDePagamentoOnline(forma: FormaDePagamento) {
    if( forma.nome === 'Pix' ) {

    }
    if( forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.Pagseguro ||
        forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.CieloCheckout ||
        forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.Pagarme ||
        forma.configMeioDePagamento.meioDePagamento === EnumMeioDePagamento.MercadoPago  ) {
      this.trocarCartao();
    }
    this.pedido.calculeTotal();
  }

  trocarCartao() {
    this.exigeCartao = true;

    if( !this.pedido.entrega.formaDeEntrega)
      return;

    const windowRef = TelaCartaoDeCreditoComponent.abraComoPopup(this.dialogService,
      true, this.pedido, this.pedido.pagamento, this.dadosCartao);
    this.telaPagamento = windowRef.content.instance;

    windowRef.result.subscribe((result: any) => {
      if( result instanceof DialogCloseResult) {

      } else if (result) {
        this.dadosCartao = result;
        this.pedido.pagamento.dadosCartao = (result as DadosCartao).outroSemDadosSensitivos();

        Object.keys(this.frm.controls).forEach(key => {
          this.frm.controls[key].updateValueAndValidity();
        });

        this.carrinhoService.salvePedido(this.pedido);
      }
    });
  }

  private formaDePagamentoExigeCartao() {
    if(!this.pagamento.formaDePagamento ||  !this.pagamento.formaDePagamento.configMeioDePagamento) return false;

    let gateway =    this.pagamento.formaDePagamento.configMeioDePagamento.meioDePagamento;

    if( this.pagamento.formaDePagamento.pix ) {
      return false;
    }

    return gateway === EnumMeioDePagamento.Pagseguro || gateway === EnumMeioDePagamento.MercadoPago ||
           gateway === EnumMeioDePagamento.CieloCheckout;
  }

  deveTerBordas() {
    return true;
  }

  precisaDeTroco(temTroco: boolean) {
    if( !temTroco ) {
      this.pagamento.trocoPara = null;
    }
  }

  deveExibirBannerTema() {
    return false;
  }

  obtenhaSaldo() {
    let descricao = formatCurrency(this.cashback.saldo, this.locale, "R$")

    if(this.empresa.integracaoFidelidade && this.empresa.integracaoFidelidade.sistema === 'gcom')
      descricao = descricao.replace('R$', this.empresa.idRede === 2 ? "R$G" : "R$C")


    return descricao;
  }

  cashbackDesabilitado() {
    let desabilitado = !this.cashback.podeUsar || !this.cashback.podeUsarNoPedido;

    if(desabilitado) return true;

    //if(this.pedido.contato.id)
      //return !this.cashback.saldo

    return false;

  }

  irParaAtualizarCadastro(){
    this.pedido.contato.atualizarCadastro = true;
    this.dominiosService.vaParaCadastro(window.location.pathname, { contato: this.pedido.contato});
    return false;
  }

  irParaLogin(){
    this.dominiosService.vaParaLogin(window.location.pathname, this.pedido.contato.telefone)
    return false;
  }

  irparaOptin(){
    this.pedido.contato.fazerOptin = true;
    this.dominiosService.vaParaCadastro(window.location.pathname, { contato: this.pedido.contato});
    return false;
  }

  marcouUsarCashback(){
    if( !this.cashback.saldo  ){
      let usuario = this.autorizacao.getUsuario();

      if(!usuario){
        if(this.pedido.contato.id)
          this.irParaLogin();
        else
          this.dominiosService.vaParaCadastro(window.location.pathname, { contato: this.pedido.contato});
      } else {
        if(this.cashback.fazerOptin){
          this.irparaOptin();
        } else {
          if(!usuario.cpf  )
             this.irParaAtualizarCadastro();

        }
      }
    }
  }

  estaHabilitado(formaDePagamento: FormaDePagamento, pedido: PedidoLoja) {
    if(!pedido.entrega) return false;

    if(pedido.entrega?.ehDelivery() && formaDePagamento.habilitarEntrega ) return true;

    if(pedido.entrega?.ehRetirada() && formaDePagamento.habilitarRetirada) return true;

    return false;
  }
}
